/* eslint-disable react/display-name */
import React from 'react';
import Loadable from 'react-loadable';
import AppBackdrop from 'layouts/Backdrop';

const LoginPage = Loadable({
  loader: () => import('views/admin/Auth/LoginPage.jsx'),
  loading: () => <AppBackdrop isOpen={true} />,
});
const LandingPage = Loadable({
  loader: () => import('views/Landing/LandingPage.jsx'),
  loading: () => <AppBackdrop isOpen={true} />,
});
const Dashboard = Loadable({
  loader: () => import('views/admin/Dashboard/Dashboard.jsx'),
  loading: () => <AppBackdrop isOpen={true} />,
});

const SchoolPage = Loadable({
  loader: () => import('views/admin/School/SchoolPage'),
  loading: () => <AppBackdrop isOpen={true} />,
});
const SchoolAdminPage = Loadable({
  loader: () => import('views/admin/SchoolAdmin/SchoolAdminPage.jsx'),
  loading: () => <AppBackdrop isOpen={true} />,
});
const TeacherSubjectsPage = Loadable({
  loader: () => import('views/admin/Employee/TeacherSubjectsPage.jsx'),
  loading: () => <AppBackdrop isOpen={true} />,
});
const SchoolStaffHubPage = Loadable({
  loader: () => import('views/admin/SchoolStaff/SchoolStaffHubPage.jsx'),
  loading: () => <AppBackdrop isOpen={true} />,
});
const EmployeeActivityPage = Loadable({
  loader: () => import('views/admin/EmployeeActivities/EmployeeActivityPage'),
  loading: () => <AppBackdrop isOpen={true} />,
});
const Reports = Loadable({
  loader: () => import('views/admin/Reports'),
  loading: () => <AppBackdrop isOpen={true} />,
});
const Configuration = Loadable({
  loader: () => import('views/admin/Configuration'),
  loading: () => <AppBackdrop isOpen={true} />,
});
const MyProfile = Loadable({
  loader: () => import('views/admin/MyProfile'),
  loading: () => <AppBackdrop isOpen={true} />,
});
const FeesPage = Loadable({
  loader: () => import('views/admin/Fees/FeesPage'),
  loading: () => <AppBackdrop isOpen={true} />,
});

const CoursePage = Loadable({
  loader: () => import('views/admin/Course/CoursePage'),
  loading: () => <AppBackdrop isOpen={true} />,
});
const BatchPage = Loadable({
  loader: () => import('views/admin/Batch/BatchPage'),
  loading: () => <AppBackdrop isOpen={true} />,
});
const SubjectPage = Loadable({
  loader: () => import('views/admin/Subject/SubjectPage'),
  loading: () => <AppBackdrop isOpen={true} />,
});
const MySchoolPage = Loadable({
  loader: () => import('views/admin/MySchool'),
  loading: () => <AppBackdrop isOpen={true} />,
});

const StudentsPage = Loadable({
  loader: () => import('views/admin/Students/StudentsPage.jsx'),
  loading: () => <AppBackdrop isOpen={true} />,
});

const StudentViewPage = Loadable({
  loader: () => import('views/admin/Students/StudentViewPage.jsx'),
  loading: () => <AppBackdrop isOpen={true} />,
});

const GuardianPage = Loadable({
  loader: () => import('views/admin/Guardian/GuardianPage'),
  loading: () => <AppBackdrop isOpen={true} />,
});

const MyStudents = Loadable({
  loader: () => import('views/admin/MyStudents'),
  loading: () => <AppBackdrop isOpen={true} />,
});

const SchoolActivities = Loadable({
  loader: () => import('views/admin/Activities'),
  loading: () => <AppBackdrop isOpen={true} />,
});

const TimeTablePage = Loadable({
  loader: () => import('views/admin/TimeTable/TimeTablePage'),
  loading: () => <AppBackdrop isOpen={true} />,
});

const AdmissionPage = Loadable({
  loader: () => import('views/admin/Admissions/AdmissionPage.jsx'),
  loading: () => <AppBackdrop isOpen={true} />,
});

const Appreciations = Loadable({
  loader: () => import('views/admin/Appreciations'),
  loading: () => <AppBackdrop isOpen={true} />,
});

const AppreciationTemplate = Loadable({
  loader: () => import('views/admin/Appreciations/AppreciationTemplate'),
  loading: () => <AppBackdrop isOpen={true} />,
});

const CloneBatch = Loadable({
  loader: () => import('views/admin/CloneBatch/index'),
  loading: () => <AppBackdrop isOpen={true} />,
});

const AcademicYearSetup = Loadable({
  loader: () => import('views/admin/AcademicYearSetup/index'),
  loading: () => <AppBackdrop isOpen={true} />,
});

const AppThemeSelector = Loadable({
  loader: () => import('views/admin/Configuration/AppThemeSelector'),
  loading: () => <AppBackdrop isOpen={true} />,
});

const PaymentStatusPage = Loadable({
  loader: () => import('views/admin/Students/components/PaymentStatusPage'),
  loading: () => <AppBackdrop isOpen={true} />,
});

const BillingsPage = Loadable({
  loader: () => import('views/admin/Billings/BillingsPage.jsx'),
  loading: () => <AppBackdrop isOpen={true} />,
});

const StaffAttendanceHubPage = Loadable({
  loader: () => import('views/admin/StaffAttendance/StaffAttendanceHubPage.jsx'),
  loading: () => <AppBackdrop isOpen={true} />,
});

// Commented out until the backend's purchase/invoice-tracking APIs are ready - re-enable this
// Loadable (and the route below) once that lands. See views/admin/InventoryPurchases/InventoryPurchasesPage.jsx.
// const InventoryPurchasesPage = Loadable({
//   loader: () => import('views/admin/InventoryPurchases/InventoryPurchasesPage.jsx'),
//   loading: () => <AppBackdrop isOpen={true} />,
// });

import constants, { employeeStatic } from 'config/constants';
// import UserAdmissionForm from 'views/admin/Admissions/components/UserAdmissionForm';

const appRoutesList = [
  {
    path: '/',
    component: LandingPage,
    sidebarView: false,
    accessRoles: 'all',
  },
  {
    path: '/admin/dashboard',
    name: 'DASHBOARD',
    icon: 'fas fa-home',
    component: Dashboard,
    sidebarView: true,
    accessRoles: 'all',
  },
  {
    path: '/admin/schools',
    name: 'SCHOOLS',
    icon: 'fa fa-school',
    component: SchoolPage,
    sidebarView: true,
    accessRoles: `${constants.roles.SA}`,
  },
  {
    path: '/admin/school-admins',
    name: 'ADMINS',
    icon: 'fas fa-user',
    component: SchoolAdminPage,
    sidebarView: true,
    roleManagement: true,
    accessRoles: `${constants.roles.SA}`,
  },
  {
    path: '/admin/our-school',
    name: 'SCHOOL',
    icon: 'fas fa-graduation-cap',
    component: MySchoolPage,
    sidebarView: true,
    roleManagement: true,
    accessRoles: `${constants.roles.SA},${constants.roles.admin},${constants.roles.teacher}`,
  },
  {
    path: '/admin/school-activities',
    name: 'SCHOOL ACTIVITIES',
    icon: 'fas fa-address-card',
    component: SchoolActivities,
    sidebarView: true,
    roleManagement: true,
    accessRoles: `${constants.roles.SA},${constants.roles.admin},${constants.roles.teacher}`,
  },
  {
    path: '/admin/batches',
    name: 'BATCHES',
    icon: 'fas fa-chalkboard-teacher',
    component: BatchPage,
    sidebarView: false,
    accessRoles: `${constants.roles.SA},${constants.roles.admin},${constants.roles.teacher}`,
  },
  {
    path: '/admin/clone-batch',
    name: 'CLONE BATCH',
    icon: '',
    component: CloneBatch,
    sidebarView: false,
    accessRoles: `${constants.roles.SA},${constants.roles.admin}`,
  },
  {
    path: '/admin/courses',
    name: 'CLASSES',
    icon: 'fa fa-layer-group',
    component: CoursePage,
    sidebarView: false,
    accessRoles: `${constants.roles.SA},${constants.roles.admin},${constants.roles.teacher}`,
  },
  {
    path: '/admin/subjects',
    name: 'SUBJECTS',
    icon: 'fas fa-book-open',
    component: SubjectPage,
    sidebarView: false,
    accessRoles: `${constants.roles.SA},${constants.roles.admin},${constants.roles.teacher}`,
  },
  {
    // Hardcoded name, not built on employeeStatic/employeesStatic - unlike the config-driven
    // Teacher label elsewhere, School Staffs (and its Teachers/Workers tabs) is meant to read the
    // same for every school regardless of that config.
    path: '/admin/school-staffs',
    name: 'SCHOOL STAFFS',
    icon: 'fas fa-users-cog',
    component: SchoolStaffHubPage,
    sidebarView: true,
    accessRoles: `${constants.roles.SA},${constants.roles.admin}`,
  },
  {
    path: '/admin/staff-attendance',
    name: 'STAFF ATTENDANCE',
    icon: 'fas fa-user-clock',
    component: StaffAttendanceHubPage,
    sidebarView: true,
    accessRoles: `${constants.roles.SA},${constants.roles.admin}`,
  },
  {
    // Renamed from the old "Teachers" (all-employees CRUD) page - that list moved to School
    // Staffs above. This route is left with just subject assignment, viewable by a teacher for
    // their own assignments (see TeacherSubjectsPage's isViewingSelf) as well as by admins.
    path: '/admin/teacher-subjects',
    name: `${employeeStatic?.toUpperCase()} SUBJECTS`,
    icon: 'fas fa-user',
    component: TeacherSubjectsPage,
    sidebarView: true,
    accessRoles: `${constants.roles.SA},${constants.roles.admin},${constants.roles.teacher}`,
  },
  {
    path: '/admin/employee-activities',
    name: `${employeeStatic?.toUpperCase()} ACTIVITIES`,
    icon: 'fas fa-chalkboard-teacher',
    component: EmployeeActivityPage,
    sidebarView: true,
    roleManagement: true,
    accessRoles: `${constants.roles.SA},${constants.roles.admin},${constants.roles.teacher}`,
  },
  {
    path: '/admin/guardians',
    name: 'GUARDIANS',
    icon: 'fas fa-user',
    component: GuardianPage,
    sidebarView: false,
    roleManagement: true,
    accessRoles: `${constants.roles.SA},${constants.roles.admin},${constants.roles.teacher}`,
  },
  {
    path: '/admin/students',
    name: 'STUDENTS',
    icon: 'fas fa-user-graduate',
    component: StudentsPage,
    sidebarView: false,
    accessRoles: `${constants.roles.SA},${constants.roles.admin},${constants.roles.teacher}`,
  },
  {
    path: '/admin/students/:studentId/view',
    name: 'STUDENTS',
    icon: 'fas fa-user-graduate',
    component: StudentViewPage,
    sidebarView: false,
    accessRoles: `${constants.roles.SA},${constants.roles.admin},${constants.roles.teacher}`,
  },
  {
    path: '/admin/school-students',
    name: 'STUDENTS',
    icon: 'fas fa-user-graduate',
    component: MyStudents,
    sidebarView: true,
    // The student detail view lives under a separate /admin/students/:id/view path (not
    // under /admin/school-students), so the sidebar wouldn't otherwise highlight "Students"
    // while looking at one - this keeps it lit up for that case too.
    activeAliases: ['/admin/students'],
    accessRoles: `${constants.roles.SA},${constants.roles.admin},${constants.roles.teacher}`,
  },
  {
    path: '/admin/fees',
    name: 'FEES',
    icon: 'fas fa-credit-card',
    component: FeesPage,
    sidebarView: true,
    roleManagement: true,
    accessRoles: `${constants.roles.SA},${constants.roles.admin},${constants.roles.teacher}`,
  },
  {
    path: '/admin/billings',
    name: 'BILLINGS',
    icon: 'fas fa-file-invoice-dollar',
    component: BillingsPage,
    sidebarView: true,
    roleManagement: true,
    accessRoles: `${constants.roles.SA},${constants.roles.admin},${constants.roles.teacher}`,
  },
  // Commented out along with the InventoryPurchasesPage Loadable above - until BE's purchase/
  // invoice-tracking APIs are ready.
  // {
  //   path: '/admin/inventory-purchases',
  //   name: 'INVENTORY PURCHASES',
  //   icon: 'fas fa-shopping-cart',
  //   component: InventoryPurchasesPage,
  //   sidebarView: true,
  //   accessRoles: `${constants.roles.SA},${constants.roles.admin}`,
  // },
  {
    path: '/admin/reports',
    name: 'REPORTS',
    icon: 'fas fa-file-pdf',
    component: Reports,
    sidebarView: true,
    roleManagement: true,
    accessRoles: `${constants.roles.SA},${constants.roles.admin},${constants.roles.teacher}`,
  },
  {
    path: '/admin/admissions',
    name: 'ADMISSIONS',
    icon: 'fas fa-users',
    component: AdmissionPage,
    sidebarView: true,
    roleManagement: true,
    accessRoles: `${constants.roles.SA},${constants.roles.admin},${constants.roles.teacher}`,
  },
  {
    path: '/admin/generate-time-table',
    name: 'GENERATE TIME TABLE',
    icon: 'fas fa-calendar',
    component: TimeTablePage,
    sidebarView: true,
    roleManagement: true,
    accessRoles: `${constants.roles.SA},${constants.roles.admin},${constants.roles.teacher}`,
  },
  {
    path: '/admin/academic-year-setup',
    name: 'NEW ACADEMIC YEAR',
    icon: 'fas fa-calendar-plus',
    component: AcademicYearSetup,
    sidebarView: true,
    roleManagement: true,
    accessRoles: `${constants.roles.SA},${constants.roles.admin}`,
  },
  {
    path: '/admin/appreciations',
    name: `APPRECIATIONS`,
    icon: 'fas fa-award',
    component: Appreciations,
    sidebarView: true,
    roleManagement: true,
    accessRoles: `${constants.roles.SA},${constants.roles.admin},${constants.roles.teacher}`,
  },
  {
    path: '/admin/appreciations/appreciation-template',
    name: `APPRECIATIONS`,
    icon: 'fas fa-award',
    component: AppreciationTemplate,
    sidebarView: false,
    roleManagement: true,
    accessRoles: `${constants.roles.SA},${constants.roles.admin},${constants.roles.teacher}`,
  },
  {
    path: '/admin/settings',
    name: 'SCHOOL SETTINGS',
    icon: 'fas fa-cog',
    component: Configuration,
    sidebarView: true,
    roleManagement: true,
    accessRoles: `${constants.roles.SA},${constants.roles.admin},${constants.roles.teacher}`,
  },
  // {
  //   path: '/admin/help-feedback',
  //   name: 'HELP & FEEDBACK',
  //   icon: 'fas fa-question-circle',
  //   component: FeesPage,
  //   sidebarView: true,
  //   roleManagement: true,
  //   accessRoles: `${constants.roles.SA},${constants.roles.admin},${constants.roles.teacher}`,
  // },
  {
    path: '/admin/my-profile',
    name: 'MY PROFILE',
    icon: '',
    component: MyProfile,
    sidebarView: false,
    roleManagement: true,
    accessRoles: `${constants.roles.SA},${constants.roles.admin},${constants.roles.teacher}`,
  },
  {
    path: '/admin/app-settings',
    name: 'APP SETTINGS',
    component: AppThemeSelector,
    icon: '',
    sidebarView: false,
    roleManagement: true,
    accessRoles: `${constants.roles.SA},${constants.roles.admin},${constants.roles.teacher}`,
  },
  {
    path: '/admin/payment-status/:paymentOrderId/:paymentStatus/:amount',
    component: PaymentStatusPage,
    sidebarView: false,
    accessRoles: 'all',
    isGuest: true,
  },
  {
    path: '/admin/login',
    component: LoginPage,
    sidebarView: false,
    accessRoles: 'all',
  },
  // {
  //   path: '/user/admission-form/:schoolId/:phoneNumber/:admissionId',
  //   component: UserAdmissionForm,
  //   sidebarView: false,
  //   accessRoles: 'all',
  // },
];

export default appRoutesList;
